module.exports = __webpack_public_path__ + "img/sold_out.95476b4f.png";